var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect2, _rect3, _rect4, _rect5, _rect6, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopOrLaptopOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 132,
    viewBox: "0 0 251 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.956 -0.000152588H4.59974C2.05914 -0.000152588 0 2.05934 0 4.59958V108.68C0 111.221 2.05914 113.28 4.59974 113.28H61.1546C61.1546 113.28 64.7521 124.405 53.5999 130.161H106.482C106.482 130.161 93.8907 125.844 97.1284 113.28H151.956C154.497 113.28 156.556 111.221 156.556 108.681V4.59958C156.556 2.05934 154.497 -0.000152588 151.956 -0.000152588Z",
    fill: "#33535F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.245 102.335C82.2495 105.2 79.1127 108.337 76.2472 106.333C76.1526 106.266 76.0666 106.181 76.0007 106.086C74.002 103.222 77.1348 100.089 79.9984 102.089C80.0931 102.154 80.1791 102.24 80.245 102.335Z",
    fill: "#17282F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.732 94.9756H4.51719C3.85873 94.9756 3.3252 94.4424 3.3252 93.784V7.43163C3.3252 6.77316 3.85873 6.23962 4.51719 6.23962H151.732C152.39 6.23962 152.924 6.7728 152.924 7.43126V93.784C152.924 94.4424 152.39 94.9756 151.732 94.9756Z",
    fill: "#FAFAF9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.82134,
    y: 13.4253,
    width: 148.317,
    height: 81.1236,
    stroke: "#FF7F33",
    strokeWidth: 0.819431
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51716 6.42126C3.96031 6.42126 3.50726 6.87431 3.50726 7.43116V93.7835C3.50726 94.34 3.96031 94.793 4.51716 94.793H151.732C152.288 94.793 152.742 94.34 152.742 93.7835V7.43079C152.742 6.87395 152.288 6.42126 151.732 6.42126H4.51716ZM151.732 95.1572H4.51716C3.75928 95.1572 3.14307 94.541 3.14307 93.7835V7.43116C3.14307 6.67328 3.75928 6.05707 4.51716 6.05707H151.732C152.489 6.05707 153.106 6.67328 153.106 7.43079V93.7835C153.106 94.541 152.489 95.1572 151.732 95.1572Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5945 9.6658C15.5945 10.3257 15.0595 10.8604 14.3996 10.8604C13.7397 10.8604 13.2051 10.3257 13.2051 9.6658C13.2051 9.00589 13.7397 8.47125 14.3996 8.47125C15.0595 8.47125 15.5945 9.00589 15.5945 9.6658Z",
    fill: "#66CC58"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35333 9.6658C8.35333 10.3257 7.8187 10.8604 7.15842 10.8604C6.49887 10.8604 5.96387 10.3257 5.96387 9.6658C5.96387 9.00589 6.49887 8.47125 7.15842 8.47125C7.8187 8.47125 8.35333 9.00589 8.35333 9.6658Z",
    fill: "#EE6B5F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8294 9.6658C11.8294 10.3257 11.2944 10.8604 10.6345 10.8604C9.97457 10.8604 9.43994 10.3257 9.43994 9.6658C9.43994 9.00589 9.97457 8.47125 10.6345 8.47125C11.2944 8.47125 11.8294 9.00589 11.8294 9.6658Z",
    fill: "#F6BE4F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1283 113.38C97.1283 113.432 89.0367 113.475 79.0575 113.475C69.075 113.475 60.9856 113.432 60.9856 113.38C60.9856 113.328 69.075 113.285 79.0575 113.285C89.0367 113.285 97.1283 113.328 97.1283 113.38Z",
    fill: "#17282F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M147.782 19.0244H8.72449C6.39389 19.0244 5.87012 18.0458 5.87012 16.8391C5.87012 15.6324 6.39389 14.6541 8.72449 14.6541H147.782C150.112 14.6541 150.909 15.6324 150.909 16.8391C150.909 18.0458 150.112 19.0244 147.782 19.0244Z",
    fill: "#33535F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3457 16.864V17.7031H10.2084V16.8753C10.2084 16.5508 10.035 16.38 9.74329 16.38C9.40532 16.38 9.19882 16.5974 9.19882 16.9387V17.7031H9.06152V15.6626H9.19882V16.5672C9.29788 16.372 9.496 16.2566 9.76259 16.2566C10.1119 16.2566 10.3457 16.4627 10.3457 16.864Z",
    fill: "#1D2A30"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6255 17.6132C11.5541 17.6817 11.4386 17.7148 11.3312 17.7148C11.0781 17.7148 10.9408 17.5663 10.9408 17.3244V16.3866H10.6768V16.2683H10.9408V15.9547H11.0781V16.2683H11.5348V16.3866H11.0781V17.3106C11.0781 17.4949 11.1691 17.5965 11.345 17.5965C11.4303 17.5965 11.5104 17.5692 11.5679 17.5171L11.6255 17.6132Z",
    fill: "#1D2A30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6824 17.6132C12.611 17.6817 12.4955 17.7148 12.3881 17.7148C12.135 17.7148 11.9973 17.5663 11.9973 17.3244V16.3866H11.7336V16.2683H11.9973V15.9547H12.135V16.2683H12.5917V16.3866H12.135V17.3106C12.135 17.4949 12.2257 17.5965 12.4019 17.5965C12.4872 17.5965 12.5669 17.5692 12.6245 17.5171L12.6824 17.6132Z",
    fill: "#1D2A30"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3576 16.9859C14.3576 16.6254 14.1074 16.3806 13.7774 16.3806C13.4475 16.3806 13.1998 16.6254 13.1998 16.9859C13.1998 17.3461 13.4475 17.5909 13.7774 17.5909C14.1074 17.5909 14.3576 17.3461 14.3576 16.9859ZM14.4952 16.9859C14.4952 17.4179 14.1901 17.7147 13.7858 17.7147C13.5327 17.7147 13.3182 17.5909 13.2027 17.3764V18.2373H13.0654V16.2681H13.1973V16.6065C13.3098 16.3865 13.5272 16.2572 13.7858 16.2572C14.1901 16.2572 14.4952 16.5569 14.4952 16.9859Z",
    fill: "#1D2A30"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7107 17.5306L14.7737 17.4206C14.884 17.5142 15.0793 17.5939 15.2908 17.5939C15.5935 17.5939 15.7144 17.4869 15.7144 17.3244C15.7144 16.9063 14.7628 17.2144 14.7628 16.6507C14.7628 16.4333 14.9445 16.2573 15.3072 16.2573C15.489 16.2573 15.6867 16.312 15.7996 16.3976L15.7363 16.5076C15.6153 16.4194 15.4587 16.3783 15.3047 16.3783C15.0239 16.3783 14.9004 16.4941 14.9004 16.6478C14.9004 17.0793 15.8521 16.7745 15.8521 17.3215C15.8521 17.5553 15.6514 17.7148 15.2854 17.7148C15.049 17.7148 14.8232 17.6351 14.7107 17.5306Z",
    fill: "#1D2A30"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.106 17.5965C16.106 17.5306 16.158 17.481 16.2214 17.481C16.2844 17.481 16.3369 17.5306 16.3369 17.5965C16.3369 17.6628 16.2844 17.7148 16.2214 17.7148C16.158 17.7148 16.106 17.6628 16.106 17.5965ZM16.106 16.3728C16.106 16.3069 16.158 16.2573 16.2214 16.2573C16.2844 16.2573 16.3369 16.3069 16.3369 16.3728C16.3369 16.4387 16.2844 16.4912 16.2214 16.4912C16.158 16.4912 16.106 16.4387 16.106 16.3728Z",
    fill: "#1D2A30"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4593 15.3877H17.5857L16.6781 17.9785H16.5518L17.4593 15.3877Z",
    fill: "#1D2A30"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1666 15.3877H18.2933L17.3854 17.9785H17.259L18.1666 15.3877Z",
    fill: "#1D2A30"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.464 9.19521L20.0735 13.1528H43.9735L42.5831 9.19521C42.3524 8.53885 41.7326 8.09961 41.0369 8.09961H23.0102C22.3145 8.09961 21.6946 8.53884 21.464 9.19521Z",
    fill: "#FF7F33"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M45.5006 9.19521L44.1101 13.1528H68.0102L66.6197 9.19521C66.3891 8.53885 65.7692 8.09961 65.0735 8.09961H47.0468C46.3511 8.09961 45.7312 8.53884 45.5006 9.19521Z",
    fill: "#FF7F33"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.5372 9.19521L68.1467 13.1528H92.0468L90.6563 9.19521C90.4257 8.53885 89.8058 8.09961 89.1101 8.09961H71.0834C70.3877 8.09961 69.7678 8.53884 69.5372 9.19521Z",
    fill: "#FF7F33"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6106,
    y: 26.6729,
    width: 46.4344,
    height: 54.9019,
    fill: "#E6E9EA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 69.2393,
    y: 31.3164,
    width: 53.8093,
    height: 5.18973,
    rx: 2.59486,
    fill: "#E6E9EA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 69.2393,
    y: 57.5381,
    width: 53.8093,
    height: 5.18973,
    rx: 2.59486,
    fill: "#E6E9EA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 69.2393,
    y: 40.0566,
    width: 30.5921,
    height: 5.18973,
    rx: 2.59486,
    fill: "#E6E9EA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 69.2393,
    y: 66.2793,
    width: 30.5921,
    height: 5.18973,
    rx: 2.59486,
    fill: "#E6E9EA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M237.681 114.702C237.681 115.856 236.745 116.791 235.591 116.791H145.045C143.891 116.791 142.955 115.856 142.955 114.702V60.0901C142.955 58.9367 143.891 58.0006 145.045 58.0006H235.591C236.745 58.0006 237.681 58.9367 237.681 60.0901V114.702Z",
    fill: "#33535F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M235.12 112.472C235.12 113.531 234.261 114.391 233.201 114.391H147.435C146.375 114.391 145.516 113.531 145.516 112.472V62.3192C145.516 61.2603 146.375 60.4008 147.435 60.4008H233.201C234.261 60.4008 235.12 61.2603 235.12 62.3192V112.472Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M232.806 111.177C232.806 112.182 231.992 112.996 230.987 112.996H149.649C148.644 112.996 147.83 112.182 147.83 111.177V63.6141C147.83 62.6091 148.644 61.7947 149.649 61.7947H230.987C231.992 61.7947 232.806 62.6091 232.806 63.6141V111.177Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M144.243 116.79L131.59 127.744L250.31 128.106L235.641 116.79H144.243Z",
    fill: "#4B6772"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M240.987 122.448H140.226L145.608 117.903H235.12L240.987 122.448Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M206.876 126.52H174.337L176.075 123.735H204.981L206.876 126.52Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M250.441 130.631C250.441 130.92 250.206 131.155 249.916 131.155H131.852C131.562 131.155 131.327 130.92 131.327 130.631V128.14C131.327 127.849 131.563 127.614 131.854 127.615L249.918 128.005C250.207 128.006 250.441 128.241 250.441 128.53V130.631Z",
    fill: "#33535F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M233.924 113.554H146.468C146.077 113.554 145.76 113.237 145.76 112.846V61.5467C145.76 61.1556 146.077 60.8386 146.468 60.8386H233.924C234.315 60.8386 234.632 61.1554 234.632 61.5465V112.846C234.632 113.237 234.315 113.554 233.924 113.554Z",
    fill: "#FAFAF9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M146.055 65.1086H234.165V112.629C234.165 113.088 233.794 113.459 233.335 113.459H146.885C146.427 113.459 146.055 113.088 146.055 112.629V65.1086Z",
    stroke: "#FF7F33",
    strokeWidth: 0.486797
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M153.049 62.8753C153.049 63.2674 152.731 63.585 152.339 63.585C151.947 63.585 151.63 63.2674 151.63 62.8753C151.63 62.4833 151.947 62.1657 152.339 62.1657C152.731 62.1657 153.049 62.4833 153.049 62.8753Z",
    fill: "#66CC58"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M148.747 62.8753C148.747 63.2674 148.43 63.585 148.037 63.585C147.645 63.585 147.328 63.2674 147.328 62.8753C147.328 62.4833 147.645 62.1657 148.037 62.1657C148.43 62.1657 148.747 62.4833 148.747 62.8753Z",
    fill: "#EE6B5F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M150.812 62.8753C150.812 63.2674 150.494 63.585 150.102 63.585C149.71 63.585 149.393 63.2674 149.393 62.8753C149.393 62.4833 149.71 62.1657 150.102 62.1657C150.494 62.1657 150.812 62.4833 150.812 62.8753Z",
    fill: "#F6BE4F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M231.577 68.4346H148.968C147.583 68.4346 147.272 67.8532 147.272 67.1363C147.272 66.4195 147.583 65.8383 148.968 65.8383H231.577C232.962 65.8383 233.435 66.4195 233.435 67.1363C233.435 67.8532 232.962 68.4346 231.577 68.4346Z",
    fill: "#33535F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M149.931 67.1519V67.6504H149.849V67.1586C149.849 66.9658 149.746 66.8644 149.573 66.8644C149.372 66.8644 149.249 66.9935 149.249 67.1963V67.6504H149.168V66.4382H149.249V66.9756C149.308 66.8596 149.426 66.791 149.584 66.791C149.792 66.791 149.931 66.9135 149.931 67.1519Z",
    fill: "#1D2A30"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M150.691 67.5969C150.649 67.6375 150.58 67.6572 150.516 67.6572C150.366 67.6572 150.284 67.569 150.284 67.4253V66.8682H150.128V66.7979H150.284V66.6116H150.366V66.7979H150.637V66.8682H150.366V67.4171C150.366 67.5265 150.42 67.5869 150.525 67.5869C150.575 67.5869 150.623 67.5707 150.657 67.5397L150.691 67.5969Z",
    fill: "#1D2A30"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M151.319 67.5969C151.277 67.6375 151.208 67.6572 151.144 67.6572C150.994 67.6572 150.912 67.569 150.912 67.4253V66.8682H150.755V66.7979H150.912V66.6116H150.994V66.7979H151.265V66.8682H150.994V67.4171C150.994 67.5265 151.048 67.5869 151.152 67.5869C151.203 67.5869 151.25 67.5707 151.285 67.5397L151.319 67.5969Z",
    fill: "#1D2A30"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M152.314 67.2244C152.314 67.0102 152.165 66.8648 151.969 66.8648C151.773 66.8648 151.626 67.0102 151.626 67.2244C151.626 67.4384 151.773 67.5837 151.969 67.5837C152.165 67.5837 152.314 67.4384 152.314 67.2244ZM152.396 67.2244C152.396 67.481 152.215 67.6573 151.974 67.6573C151.824 67.6573 151.697 67.5837 151.628 67.4563V67.9678H151.547V66.7979H151.625V66.9989C151.692 66.8683 151.821 66.7915 151.974 66.7915C152.215 66.7915 152.396 66.9695 152.396 67.2244Z",
    fill: "#1D2A30"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M152.524 67.5478L152.561 67.4824C152.627 67.538 152.743 67.5854 152.869 67.5854C153.048 67.5854 153.12 67.5218 153.12 67.4253C153.12 67.1769 152.555 67.36 152.555 67.025C152.555 66.8959 152.663 66.7914 152.878 66.7914C152.986 66.7914 153.104 66.8238 153.171 66.8747L153.133 66.94C153.061 66.8877 152.968 66.8632 152.877 66.8632C152.71 66.8632 152.637 66.932 152.637 67.0233C152.637 67.2797 153.202 67.0986 153.202 67.4236C153.202 67.5625 153.083 67.6572 152.865 67.6572C152.725 67.6572 152.591 67.6098 152.524 67.5478Z",
    fill: "#1D2A30"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M153.353 67.5869C153.353 67.5478 153.384 67.5183 153.421 67.5183C153.459 67.5183 153.49 67.5478 153.49 67.5869C153.49 67.6263 153.459 67.6572 153.421 67.6572C153.384 67.6572 153.353 67.6263 153.353 67.5869ZM153.353 66.86C153.353 66.8208 153.384 66.7914 153.421 66.7914C153.459 66.7914 153.49 66.8208 153.49 66.86C153.49 66.8991 153.459 66.9303 153.421 66.9303C153.384 66.9303 153.353 66.8991 153.353 66.86Z",
    fill: "#1D2A30"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M154.157 66.2763H154.232L153.693 67.8154H153.618L154.157 66.2763Z",
    fill: "#1D2A30"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M154.577 66.2763H154.652L154.113 67.8154H154.038L154.577 66.2763Z",
    fill: "#1D2A30"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M156.536 62.5952L155.71 64.9462H169.908L169.082 62.5952C168.945 62.2053 168.577 61.9443 168.163 61.9443H157.454C157.041 61.9443 156.673 62.2053 156.536 62.5952Z",
    fill: "#FF7F33"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M170.815 62.5952L169.989 64.9462H184.187L183.361 62.5952C183.224 62.2053 182.856 61.9443 182.443 61.9443H171.734C171.321 61.9443 170.952 62.2053 170.815 62.5952Z",
    fill: "#FF7F33"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M185.095 62.5952L184.269 64.9462H198.467L197.641 62.5952C197.504 62.2053 197.135 61.9443 196.722 61.9443H186.013C185.6 61.9443 185.232 62.2053 185.095 62.5952Z",
    fill: "#FF7F33"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 152.464,
    y: 72.9785,
    width: 27.5851,
    height: 32.6154,
    fill: "#E6E9EA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 184.917,
    y: 75.7383,
    width: 31.9663,
    height: 3.08305,
    rx: 1.54152,
    fill: "#E6E9EA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 184.917,
    y: 91.3154,
    width: 31.9663,
    height: 3.08305,
    rx: 1.54152,
    fill: "#E6E9EA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 184.917,
    y: 80.9287,
    width: 18.1737,
    height: 3.08305,
    rx: 1.54152,
    fill: "#E6E9EA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 184.917,
    y: 96.5078,
    width: 18.1737,
    height: 3.08305,
    rx: 1.54152,
    fill: "#E6E9EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopOrLaptopOnly);
export default __webpack_public_path__ + "static/media/desktop-or-laptop-only.6b23d6c5c9e53325d8fc08aebfed5524.svg";
export { ForwardRef as ReactComponent };